export default "__VITE_ASSET__BWKoNg6z__"